import SwivlChat from "../SwivlChat";
import { Message,CommandPayload,CommandPayloadCommandType } from "@swivl/swivl-lib";


function cleanElement(element) {
  if (!element){ return null; }
  return element.replace("#", "");
}
function scrollToElement(elementToScrollTo) {
    if (!elementToScrollTo || !elementToScrollTo.offsetTop || !elementToScrollTo.parentNode) {  return; }
    var element = elementToScrollTo.parentNode;
    const to = elementToScrollTo.offsetTop;
    const duration = Math.abs(element.scrollTop - to) * 1.3;
    const start = element.scrollTop;


  function easeInOutCubic(t) {
     return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
   }

   const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();

  function animateScroll(){

      const now = 'now' in window.performance ? performance.now() : new Date().getTime();
      const time = Math.min(1, ((now - startTime) / duration));
      const timeFunction = easeInOutCubic(time);
      element.scrollTop = Math.ceil((timeFunction * (to - start)) + start);

      if (element.scrollTop != to) {
        requestAnimationFrame(animateScroll);
      }
  };

  animateScroll();
}




export class CommandHandler {
  delegate: SwivlChat;

  constructor(delegate:SwivlChat) {
    this.delegate = delegate;
  }
  handleCommandMessage(message:Message) {

    const type = (message.payload as CommandPayload).type;
    const payload = (message.payload as CommandPayload).payload;

    
    if (type) {
      if  (type === CommandPayloadCommandType.NavigateTo && payload.url) {
        if (!this.delegate.props.canTakeOver && !this.delegate.props.isTestBot) {
          window.location.href = payload.url;
        }
      }

      if  (type === CommandPayloadCommandType.LoadPastMessages) {

        
        this.delegate.list.loadPastMessages()
        return;
      }
      if  (type === CommandPayloadCommandType.ClearMessages) {
        this.delegate.list.clearMessages()
        return;
      }

      if  (type === CommandPayloadCommandType.OpenOrClose) {

        if ((window as any).Swivl) {
          if (payload.open) {
            (window as any).Swivl.open();
          } else {
            (window as any).Swivl.close();
          }
        }
        return;
      }


      if  (type == "analytics") {
        if (payload.platform && payload.platform == "GTM") {
          if (!payload.event) {  return; }
          if ((window as any).dataLayer) {

            (window as any).dataLayer.push({event:payload.event});
          } else {
            
          }
        } else if (payload.platform && payload.platform == "CustomDimension") {
          
          
          if (payload.dimensionType === "GA") {
            
            (window as any).ga('set', payload.dimensionName, payload.dimensionValue);

          } else {
            
            if (payload.dimensionIndex && payload.dimensionName && payload.trackingId) {
              (window as any).gtag('config', payload.trackingId, {
                  'custom_map': {[`dimension${payload.dimensionIndex}`] : payload.dimensionName}
              });
            } else {
              
            }
          }
   
        

        } else if (payload.platform && payload.platform == "GA") {
          try {
            const category  = payload.category || "Swivl-Category";
            const action  = payload.action || "Swivl-Action";

            const label  = (payload.label && payload.label.length) ?  payload.label  : "Swivl-Label";
            (window as any).ga('send', 'event', category, action, label);

          } catch (e) {
            
            
          }
        } else if (payload.platform && payload.platform == "Amplitude") {
          if (!payload.event) {  return; }
          if ((window as any).amplitude) {
            (window as any).amplitude.getInstance().logEvent(payload.event);
          }

        } else {
          const action  = payload.action || "Swivl-Action";
          const category  = payload.category || "Swivl-Category";
          const label  = (payload.label && payload.label.length) ?  payload.label  : null;
          // const value  = (payload.action && payload.action.length) ?  payload.value  : null;

          if((window as any).gtag) {
            var gtagPayload:any = { 'event_category': category };
            if (label) { gtagPayload.event_label  = label; }

            if (payload.sendDimension &&  payload.dimensionName &&  payload.dimensionValue) {
              gtagPayload[payload.dimensionName] = payload.dimensionValue; 
              
              
            }
            (window as any).gtag('event', action, gtagPayload);


          } else  {
            
          }
        }
        return;
      }

      if  (type == "custom") {
        if (this.delegate.props.commandCallback && payload) {
          this.delegate.props.commandCallback(payload)
        } else {
          
        }
        return;
      }

      const element:any = (payload && payload.element && cleanElement(payload.element)) ? document.getElementById(cleanElement(payload.element)) : null;
      if (!element) {   return; }

      if  (type == "scrollElement") {
        scrollToElement(element);
       }
      if  (type == "replaceText" && payload.replaceWith ) {
          element.innerHTML = payload.replaceWith;
       }
       if  (type == "replaceImage" && payload.replaceWith) {
         element.src = payload.replaceWith;
       }
    }


  }

}
